<div class="container-fluid reporting-general-page px-3 px-md-4 py-3">
  <div class="row">
    <div class="col-md-6 mx-auto text-center text-white">
      <app-alert [titulo]="'Reportes Generales'"></app-alert>
    </div>
  </div>
  <div class="row my-3 align-items-stretch reporting-general-filters">
    <div class="col-5 px-1">
      <mat-card class="general-report-card selection-card">
        <mat-card-content class="selection-card-content">
          <app-selection-list (selectedOptionEmit)="filter($event, false, true)"></app-selection-list>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-7 px-1 general-filter-column">
      <app-filter-card class="general-filter-card" [showRangePicker]="true"
        (filterEmit)="filter($event)" [hasLegajoInput]="false" [hasExportExcelButton]="true"
        [useModernActions]="true" [reportSelected]="!!paramEntity.SpName"
        (printExcelEmit)="printExcel($event)"
        [exportExcelButtonDisabled]="false"></app-filter-card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-table-report [setTableParams]="paramEntity"></app-table-report>
    </div>
  </div>
</div>
